export default {
  data: () => ({
    form: {},
    errors: {},
    submitting: false,
    fetchForm: true,
  }),

  created() {
    if (!this.fetchForm) {
      return;
    }

    let url = this.$route.path;

    this.$api.get(url)
      .then(response => {
        for (const key in response.data) {
          this.$data[key] = response.data[key];
        }
      });
  },

  methods: {
    validate() {
      this.errors = {};

      let url = this.$route.path;

      this.$api.post(url, this.form)
        .then(response => {
          this.$emit('validated', response.data);
          if (typeof this.afterValidate === 'function') {
            this.afterValidate(response.data);
          }
        })
        .catch(error => {
          if (error?.response?.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },

    submit() {
      this.submitting = true;
      this.errors = {};

      const method = this.$route.params.id ? 'put' : 'post';
      const url    = this.$route.path.replace(/\/edit$/, '').replace(/\/create$/, '');

      this.$api[method](url, this.form)
        .then(response => {
          if (typeof this.onSubmitSuccess === 'function') {
            this.onSubmitSuccess(response.data);
          }
        })
        .catch(error => {
          if (error?.response?.status === 422) {
            this.errors = error.response.data.errors || {};
          }
          if (typeof this.onSubmitError === 'function') {
            this.onSubmitError(error);
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
}